// extracted by mini-css-extract-plugin
module.exports = {"callout_3STgN5":"callout_3STgN5","icon_2fLGWz":"icon_2fLGWz","children-content_2e7noK":"children-content_2e7noK","warning_1X5xPd":"warning_1X5xPd","info_gij51h":"info_gij51h"};